import Alpine from "alpinejs";
import activityTeacherNotesApp from "./notes.js";
import resourceShareableLinkApp from "./shareable-link.js";
import resourceToolbarApp from "./toolbar.js";

export function registerResourceComponents() {
    Alpine.data("activityTeacherNotesApp", activityTeacherNotesApp);
    Alpine.data("resourceShareableLinkApp", resourceShareableLinkApp);
    Alpine.data("resourceToolbarApp", resourceToolbarApp);
}